import { PageRouteBuilder } from "@common/route/page-route-builder";
import { AboutPageComponent } from "./about-page.component";

export const aboutPageRoute = new PageRouteBuilder()
    .usingNgComponent("adapt-about-page", AboutPageComponent)
    .atUrl("/about")
    .requiresLogin(false)
    .build();
